module.exports = "/images/PAULO_CESAR_DA_SILVA.jpg?2c1f1914288e97e8426cde38e52f8240";